// @flow
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import organisations from './organisations';
import activeOrganisation from './activeOrganisation';
import currentOrganisation from './currentOrganisation';
import locations from './locations';
import currentLocation from './currentLocation';
import campaigns from './campaigns';
import campaignDeliveryPoints from './campaignDeliveryPoints';
import bookings from './bookings';
import currentInsightSet from './currentInsightSet';
import currentShapeSet from './currentShapeSet';
import currentCustomer from './currentCustomer';
import insightSets from './insightSets';
import shapeSets from './shapeSets';
import industries from './industries';
import referenceLayers from './referenceLayers';
import customers from './customers';
import currentIndustry from './currentIndustry';
import currentReferenceLayer from './currentReferenceLayer';
import currentBooking from './currentBooking';
import currentCampaign from './currentCampaign';
import currentCampaignBooking from './currentCampaignBooking';
import currentUser from './currentUser';
import authentication from './authentication';
import users from './users';
import settings from './settings';
import visibilityTypes from './visibilityTypes';
import { reducer as formReducer } from 'redux-form';

const rootReducer = combineReducers({
  authentication,
  organisations,
  locations,
  campaigns,
  campaignDeliveryPoints,
  bookings,
  insightSets,
  shapeSets,
  industries,
  referenceLayers,
  customers,
  users,
  activeOrganisation,
  currentOrganisation,
  currentLocation,
  currentInsightSet,
  currentShapeSet,
  currentCustomer,
  currentIndustry,
  currentReferenceLayer,
  currentCampaign,
  currentCampaignBooking,
  currentBooking,
  currentUser,
  settings,
  form: formReducer,
  routing: routerReducer,
  visibilityTypes
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/root.js